/* eslint-env browser */

'use strict';

// only loads when NODE_ENV === 'development'
require('preact/debug');

const { h, render } = require('phy');
const PromoWrapperComponent = require('../../components/desktop/promo_wrapper_component');

const initPromoCodeV2 = ({ promoCodeV2 }) => {
  if (!promoCodeV2) return null;

  const container = document.querySelector('.promo-code-v2-container');

  const { props } = promoCodeV2;

  return render(
    h(PromoWrapperComponent, props),
    container,
    container.lastChild
  );
};

const init = (payload, done) => {
  initPromoCodeV2(payload);
  return done();
};

module.exports = { init };
